<template>
  <div>
    <h1>Reglas del Cliente</h1>
    <table-client-rules :client_id="client_id"></table-client-rules>
    <div></div>
  </div>
</template>

<script>
import TableClientRules from "./../clients/client-rules/table-client-rules";
export default {
  props: ["client_id"],
  name: "",
  data() {
    return {};
  },
  methods: {},
  components: {
    "table-client-rules": TableClientRules,
  },
};
</script>

<style lang="" scoped></style>
